import { render, staticRenderFns } from "./copyrightDetails.vue?vue&type=template&id=09fada3a&scoped=true&"
import script from "./copyrightDetails.vue?vue&type=script&lang=js&"
export * from "./copyrightDetails.vue?vue&type=script&lang=js&"
import style0 from "./copyrightDetails.vue?vue&type=style&index=0&id=09fada3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fada3a",
  null
  
)

export default component.exports